import Cookies from "js-cookie";

export function getCookie(cookieName) {
  return Cookies.get(cookieName);
}

export function setCookie(cookieName, value) {
  return Cookies.set(cookieName, value);
}

export function removeCookie(cookieName) {
  return Cookies.remove(cookieName);
}

export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function resetAllStores(store) {
  Object.keys(store._modulesNamespaceMap).forEach((ns) => {
    if (store._mutations[`${ns}RESET_STATE`]) {
      store.commit(`${ns}RESET_STATE`);
    }
  });
}
